import { pictures, getPrices } from '@/utils/formatters/formattedProduct';

const appUrlDefault = 'https://book24.ru/';

export const reviewsProductDetail = (reviews = []) => {
  if (!Array.isArray(reviews)) return [];

  return reviews.map(item => ({
    body: item.review,
    rating: item.bookRating,
  }));
};

export const listingItem = (item, options = {}) => {
  if (!item) throw new Error('[DDM:listingItem] Не заполнен обязательный параметр');
  const { appUrl = appUrlDefault } = options;
  const urlProduct = new URL(item.link, appUrl);
  return {
    age: item.age,
    author: item.authorList.length ? item.authorList[0].name : null,
    category: item.categoryListName,
    categoryId: String(item?.category?.id || 0),
    currency: 'RUB',
    id: String(item.id),
    imageUrl: item.images.x2,
    isTodayDeliveryAvailable: false,
    manufacturer: item.publishingHouse?.name,
    name: item.name,
    nomcode: item.nomcode,
    rrc: item.isRrc ? '1' : '0',
    stock: item.quantity,
    thumbnailUrl: item.images.x1,
    unitPrice: item.prices.base,
    unitSalePrice: item.prices.price,
    url: urlProduct.href,
    isPreOrder: item.isPreOrder,
  };
};

export const productDetail = ({ product, reviews }, options = {}) => {
  const { appUrl = appUrlDefault } = options;
  return {
    ...listingItem(product, { appUrl }),
    description: product.description,
    htmlBlocks: 'cover,rate,annotation,reviews',
    imageCount: product?.productImage?.length || [],
    reviews: reviewsProductDetail(reviews),
  };
};

export const favoriteItem = (item, type) => {
  const name = type === 'add'
    ? 'Added Product to Wishlist'
    : 'Removed Product from Wishlist';
  return {
    category: 'Ecommerce',
    name,
    product: {
      id: String(item.id),
      skuCode: Number(item.id),
      unitSalePrice: item.price,
      unitPrice: item.oldPrice,
      currency: 'RUB',
      categoryId: item.categoryId,
    },
  };
};

const getCategory = (category) => {
  const categoryFinal = [];

  if (category.name) {
    categoryFinal.push(category.name);
  }
  if (Array.isArray(category.parentCategory)) {
    const parentCategory = category.parentCategory.sort((a, b) => {
      if (a.depthLevel > b.depthLevel) return 1;
      if (a.depthLevel < b.depthLevel) return -1;
      return 0;
    });
    parentCategory.forEach((item) => {
      categoryFinal.push(item.name);
    });
  }

  return categoryFinal;
};

export const getLineItemsBasket = (itemCart, { appUrl = appUrlDefault }) => {
  const product = { ...itemCart.product };
  const urlProduct = new URL(`/product/${product.code}-${product.id}/`, appUrl);
  const images = pictures(product.picture, { sizePicWidth: 220, sizePicHeight: 284 });
  const prices = getPrices(product.amount);

  return {
    product: {
      id: product.id,
      url: urlProduct.href,
      imageUrl: images.x2,
      thumbnailUrl: images.x1,
      name: product.name,
      manufacturer: product.publishingHouse?.name ?? '',
      category: getCategory(product?.category ?? {}),
      currency: 'RUB',
      unitPrice: prices.base,
      unitSalePrice: prices.price,
      categoryId: String(product?.category?.id || 0),
    },
    quantity: itemCart.quantity,
    subtotal: prices.price * itemCart.quantity,
    totalDiscount: 0,
  };
};
